module.exports = __webpack_public_path__ + "img/eye.22821c31.svg";